import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// clsx supports conditional classNames
// twMerge makes sure classNames that appear later in inputs override className earlier values
// e.g. an element with "p-1" and "p-2" classNames will have p-2
// This avoids dealing with CSS cascading/specificity
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
